import './rewards.css';
import '@fontsource/open-sauce-one';
import Coupon from './component/Coupon/coupon';
import SpinTheWheel from './component/SpinTheWheel/spinwheel';
import Card from './component/Card/Card';
import React, { useEffect, useState } from 'react';
import Winnings from './component/Winnings/Winnings';
import {useHistory, withRouter} from 'react-router-dom';
import BottomDrawer from './component/Winnings/BottomDrawer';
import baseURLGlobal from '../../utils/util';
import { SOURCE_HOME, } from './util';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';
import Lottie from 'react-lottie';
import studentStripAnimation from '../../assets/json/navratri-strip.json';
import { cosmosTrackService } from '../../cosmosTracking/cosmosTrackService';
import {sale_video_student, Spin_the_wheeler} from '../../cosmosTracking/cosmosEvents';
import { directDeepLink } from '../../tutor/webviewreboot/util';
import TutorMessage from "./component/TutorMessage/TutorMessage";
import studentVideo from '../../assets/videos/student-holi-video-26.mp4';
import HeaderImg from '../../assets/images/happy-holi-overview-tittle-2026.png'
import graphIcon from '../../assets/images/graph-icon.png'
import styleDumru from '../../assets/images/dhool-student26.png';
import holiGun from '../../assets/images/holiGun-student26.png';
import gulalEffect from '../../assets/images/gulal-student-buttom26.webp';


function Rewards() {
	const baseUrl = baseURLGlobal;
	const [data, setData] = useState({});
	const [rotating, setRotating] = useState(false);
	const [openModals, setOpenModals] = useState(false);
	const [modalsData, setModalsData] = useState();
	const [winnings, setWinnings] = useState(0);
	const [promoTypeId, setPromoTypeId] = useState('');
	const [showBottomDrawer, setShowBottomDrawer] = useState(false);
	const [spinnerModal, setSpinnerModal] = useState(false);
	const [drawerContent, setDrawerContent] = useState({});

	const stripAnimation = {
		loop: true,
		autoplay: true,
		animationData: studentStripAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	let url = new URL(window.location.href);
	let token = url.searchParams.get('token');

	const handleDrawerOpen = (drawerContent) => {
		setDrawerContent(drawerContent);
		setShowBottomDrawer(true);
	};
	const handleDrawerClose = () => {
		setDrawerContent({});
		setShowBottomDrawer(false);
	};

	const handleModals = () => {
		// setOpenModals(true);
		setRotating(true);
		setTimeout(() => {
			setOpenModals(true);
		}, 5000);
	};

	const _postSpinHandler = async () => {
		setRotating(false); // this is useless though for now
		let data = await postAwards();
	};

	const postAwards = async () => {
		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: JSON.stringify({ promoTypeId }),
		};

		return await fetch(
			`${baseUrl}/v2/course/campaign/student/award/redeemVoucher`, requestOptions
		)
			.then((response) => response.json())
			.then((results) => setModalsData(results.data))
			.catch((error) => {
				console.log('error', error);
				return null;
			});
	};

	const getAwards = () => {
		let myHeaders = new Headers();
		myHeaders.append('api-version', '25');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow',
		};
		fetch(`${baseUrl}/v2/course/campaign/student/home`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				console.log(result, 'dddd')
				setData(result) ;
				let winnerobj = result?.data?.userAwards?.scratchCards.find(
					(res) => res?.winner
				);
				setPromoTypeId(winnerobj?.id);
			})
			.catch((error) => console.log('error', error));
	};

	const handleSpinBtn = function (){
		let DeepLink = {
			screen: '',
			paramOne: '',
			paramTwo: '',
			paramTracking: 'StudentSideSpinWheelClickTracking',
			paramThree: '',
			paramSource: '',
		};
		handleModals();
		window?.mobile?.onDeeplinkExecutedV2(
			JSON.stringify(DeepLink)
		);
		directDeepLink(DeepLink, SOURCE_HOME);
	}

	const handleCouponModal = function (){
		setTimeout(() => {
			setOpenModals(false);
			setSpinnerModal(false);
		}, 2000);
		setWinnings(winnings + 1);
	}
	const isIphone = () => {
		return /iPhone/i.test(navigator.userAgent);
	};

	useEffect(() => {
		getAwards();
	}, [winnings]);
	return (
		<div className="layoutBackground" id="Background">
			<img src={styleDumru} className='style-dumru' alt="title" />
			<img src={holiGun} className='holi-gun' alt="title" />
			<div className="student-page-header">
				<img src={HeaderImg} alt="title" />
				<hr className='student-page-header-hr' />
				<p className='student-page-header-subtittle'>Complete tasks & Win Amazing Gift Vouchers on every purchase above Rs. 100/-</p>
				<video
					poster="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/video-thumbnail-dark.png"
					src={studentVideo}
					controls
					controlsList="nofullscreen nodownload noplaybackrate"
					disablePictureInPicture
					playsinline
					onPlay={()=>cosmosTrackService(sale_video_student)}>
				</video>
				{
					!isIphone() ?
				<div className="bottom-coupon-box">
					<img src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/student-coupon-box-fallback26.png"} width={24} alt="img"/>
					<p>About <span>80% students</span> won brand vouchers in every festive sale!</p>
					<Lottie options={stripAnimation}></Lottie>
				</div> :
				<img className="bottom-coupon-img-box" src="https://cdn-cp-assets-public.classplus.co/campaigns-assets/student-coupon-box-fallback2026.png" alt="fallback"/>
				}
			</div>
			{
				data?.data?.campaignTutorMessage &&
				<TutorMessage message={data?.data?.campaignTutorMessage || "Tutor Message"} orgLogo={data?.data?.campaignOrg?.appLogo || "Org Logo"} orgName={data?.data?.campaignOrg?.orgName || "Org Name"}/>
			}
			{data?.data?.courses &&
				<div className="layoutSlider">
					<h2>Purchase Course & get chance to <span style={{color: '#D73D72'}}>win amazing brand vouchers!</span></h2>
					<Swiper className="layoutSwiper"
							pagination={{clickable: true}}
							modules={[Pagination]} slidesPerView={1.1}>
						{data?.data?.courses?.map((item, index)=>{
							return(
								<SwiperSlide key={item.id || index}>
									<Card data={item}/>
								</SwiperSlide>
							)
						})}
					</Swiper>
				</div>
			}
			<div className="layoutReward">
				<h4>Spin and Win</h4>
				<p>Choose your favorite brand and spin the wheel to get exciting vouchers of that brand.</p>
				<div className="RewardCard">
					<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/christmas-spin-aniamtiongif.gif" alt="animation"/>
					<button onClick={() => {cosmosTrackService(Spin_the_wheeler);setSpinnerModal(true);}}>Spin Now</button>
				</div>
			</div>
			{spinnerModal &&
				<div className="spinModalOverlay">
					<div className="overlayClose" onClick={() => {setSpinnerModal(false)}}>
						<img src="https://cdn-wl-assets.classplus.co/production/single/learn/c07048ce-6b73-44ce-b8ea-7cc5cba0c415.png" alt="close" width={18}/>
					</div>
					<div className="overlayContent">
						<SpinTheWheel
							prizeList={data?.data?.userAwards?.scratchCards}
							rotating={rotating}
							postSpinHandler={_postSpinHandler}
						/>
						{data?.data?.userAwards?.scratch ?(
								<button className="overlayActionBtn" onClick={handleSpinBtn}>Tap to Spin</button> ):
							(
								<>
									<button className="overlayActionBtn" disabled={true}>Tap to Spin</button>
									<p>Purchase a course above ₹100 to unlock the wheel</p>
								</>
							)
						}
					</div>
				</div>
			}
			
			{data?.data?.userAwards?.awardsList &&
				<div className="layoutWining">
					<h4>Your Winnings</h4>
					<div className="WinnerCardGroup">
						{data?.data?.userAwards?.awardsList?.map((item) => (
							item.id === 44 ? null : (
								<Winnings key={item.id} data={item} handleDrawerOpen={handleDrawerOpen} />
							)
						))}
					</div>
				</div>
			}

			{openModals &&
				<div className="couponModalOverlay">
					<div className="overlayClose" onClick={handleCouponModal}>
						<img src="https://cdn-wl-assets.classplus.co/production/single/learn/c07048ce-6b73-44ce-b8ea-7cc5cba0c415.png" alt="close" width={18}/>
					</div>
					<div className="overlayContent">
						<h4>Congratulations!!</h4>
						<Coupon datas={modalsData} />
						<p>Copy the Coupon code to redeem</p>
					</div>
				</div>
			}
			{showBottomDrawer && (
				<BottomDrawer
					drawerContent={drawerContent}
					closeDrawer={handleDrawerClose}
				/>
			)}

			<img className="gulal-effect" src={gulalEffect} alt="bottom"  />
		</div>
	);
}

export default withRouter(Rewards);
